import { generateBFFUrl, SERVICEABLE_PINCODE } from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import { AxiosError, AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { CartData } from '@/types/cart';

export const fetchServiceAblePincode = async (pincode: string): Promise<CartData> => {
  const serviceablePincode = await axiosInstance
    .get(generateBFFUrl(`${SERVICEABLE_PINCODE}${pincode}`), {})
    .then(({ data }) => {
      return data;
    })
    .catch((error: AxiosError) => {
      console.log(error, 'fetch cart');
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return serviceablePincode;
};
